define('modules/form_editor/behaviours/has_error_message',['require','exports','module','../../editor/models/editorstate','lodash','jquery'],function(require,exports,module) {
  'use strict';

  var EditorState = require('../../editor/models/editorstate'),
    _ = require('lodash'),
    $ = require('jquery');

  module.exports = {
    _hasErrorMessageInit: function(init) {
      init.apply(this, _.rest(arguments));
      this.defaultErrorMessage = this._getDefaultMessage();

      if (!this.model.has('errorMessage')) {
        this._saveErrorMessage();
      }

      this.listenTo(this.model, 'change:labelText', function() {
        if (this.model.previous('labelText') !== this.model.get('labelText')) {
          if (this.model.get('errorMessage') === this.defaultErrorMessage) {
            this.defaultErrorMessage = this._getDefaultMessage();
            this._saveErrorMessage();
          }
        }
      });
    },

    _hasErrorMessageRender: function(originalRender) {
      originalRender.apply(this);

      return this.addErrorMessages();
    },

    addErrorMessages: function() {
      var controlTags = ['input', 'select', 'textarea'],
        exceptionSelectors = ['.js-password-confirmation', '[type=hidden]'],
        $controlCol = this.$el
          .find(controlTags.join(','))
          .not(exceptionSelectors.join(',')),
        $control = $controlCol.last(),
        $parent = $control.parent(),
        errorMessage = this.model.get('errorMessage');

      if ($control && $control.length) {
        $control.attr('data-val-message', errorMessage);

        if (
          EditorState.getAMPState() &&
          this.controlNeedsAMPValidation($control)
        ) {
          this._addAMPValidation($control);
        }

        // Adding the custom error message to the special date component.
        if ($parent.siblings('.js-custom-date')) {
          $parent.siblings('.js-custom-date')
            .attr('data-val-message', errorMessage);
        }

        // Adding the custom error to all radios/checkboxes buttons (if needed):
        if ($control.is('[type=radio]') || $control.is('[type=checkbox]')) {
          $controlCol.not($control).each(function () {
            $(this).attr('data-val-message', errorMessage);
          });
        }
      }

      return this;
    },

    controlNeedsAMPValidation: function($control) {
      var fields = [
        'input',
        'select',
        'textarea',
        '.js-email',
        '.js-terms',
        '.js-telephone',
        '.js-items'
      ];

      return $control.is(fields.join(','));
    },

    _addAMPValidation: function($control) {
      var hasPattern = $control.attr('pattern'),
        isRequired = $control.attr('required'),
        values = [];

      if (isRequired) {
        values.push('valueMissing');
      }

      if (hasPattern && (hasPattern.length > 0)) {
        values.push('patternMismatch');
      }

      if ($control.attr('type') === 'email') {
        values.push('typeMismatch');
      }

      values.push('customError');

      $(this._getAMPValidationMessage($control, values)).insertAfter($control);
    },

    _getAMPValidationMessage: function($control, values) {
      var controlId = $control.attr('id') || $control.attr('name'),
        controlName = $control.attr('name'),
        self = this;

      return ($.map(values, function(value) {
        var errorMessage = self.getErrorMessageByType($control, value);

        return '<span class="hidden-no-amp" data-control-name="' + controlName + '"' +
          ' validation-for="' + controlId + '"' +
          ' visible-when-invalid="' + value + '">' +  errorMessage + '</span>';
      })).join('');
    },

    getErrorMessageByType: function($control, $type) {
      var typesForDefaultMessage = ['valueMissing', 'typeMismatch', 'patternMismatch'];

      if (_.contains(typesForDefaultMessage, $type)) {
        return $control.data('valMessage');
      }

      return '';
    },

    _getDefaultMessage: function() {
      var defaultKey = this.model.defaultErrorMsgKey,
          defaultMessage = '';

      try {
        var defaultsModel = EditorState.getVariant().getPropertyGroup('page:defaults'),
            lang = defaultsModel.get('language');
        defaultKey += ('_' + lang);
      } finally {
        if (defaultKey) {
          defaultMessage = $.i18n.t(defaultKey).replace('{0}', this.model.get('labelText'));
        }

        return defaultMessage;
      }
    },

    _saveErrorMessage: function() {
      this.model.set('errorMessage', this.defaultErrorMessage);
    },

    mixed: function(klass, prototype) {
      prototype.initialize = _.wrap(prototype.initialize || _.identity, this._hasErrorMessageInit);
      prototype.render = _.wrap(prototype.render, this._hasErrorMessageRender);
    }
  };
});

